// src/js/components/Evaluation/Results.js
import React, { Component } from "react";
import { connect } from "react-redux";

import './ModuleResults.css';
import SubmoduleResults from "./SubmoduleResults";

const mapStateToProps = state => {
    return {
        benchmark: state.data.benchmark.modules
    };
};

function mapDispatchToProps(dispatch) {
    return {};
}

class ConnectedModuleResults extends Component {
    constructor(props) {
        super(props);
        this.DisplaySubmodule = this.DisplaySubmodule.bind(this);
    }

    DisplaySubmodule(submodule, index) {
        return (
            <SubmoduleResults key={index} submodule={submodule} submoduleindex={index} moduleindex={this.props.index} />
        )
    }

    render() {
        // console.log(this.props.benchmark);
        // console.log(this.props.module);
        // console.log(this.props.index);

        return(
            <div className="evResultModule">
                <h2>{this.props.benchmark[this.props.index].heading}</h2>
                {this.props.module.map((submodule, index) => this.DisplaySubmodule(submodule,index) ) }
            </div>
        )
    }
}
const ModuleResults = connect(mapStateToProps,mapDispatchToProps)(ConnectedModuleResults);

export default ModuleResults;